import React from 'react';
import slide1Img from '../../../images/slide1.jpg';

const images = [slide1Img];

function SlideItem({ content }) {
    return (
        <div
            style={{
                height: '100%',
                width: '100%',
                backgroundImage: `url('${content}')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no - repeat',
                backgroundPosition: 'center',
            }}
        />
    );
}

const Indicators = (props) => {
    const listIndicators = images.map((image, index) =>
        <li
            key={index}
            className={props.currentSlide === index ? 'active' : ''}
            onClick={() => props.changeSlide(index)}
        >{index + 1}</li>
    );
    return (
        <ul className="indicators">
            {listIndicators}
        </ul>
    );
};

function Slider() {
    const [slideInfo, setSlideInfo] = React.useState({ slideShow: images[0], slideIndex: 0 });
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [pause, setPause] = React.useState(false);
    const timeoutRef = React.useRef(null);
    const timePauseRef = React.useRef(null);
    const { slideShow, slideIndex } = slideInfo;

    React.useEffect(() => {
        if (pause === true) {
            clearInterval(timeoutRef.current);
            timePauseRef.current = setTimeout(() => {
                clearInterval(timePauseRef.current);
            }, 8000);
            setPause(false)
        }
    }, [pause]);

    const goTo = (direction) => {
        let index = 0;
        switch (direction) {
            case 'auto':
                index = currentIndex + 1;
                setCurrentIndex(index >= images.length ? 0 : index);
                break;
            case 'prev':
                index = currentIndex - 1;
                setCurrentIndex(index < 0 ? images.length - 1 : index);
                setPause(true)
                break;
            case 'next':
                index = this.currentIndex + 1;
                setCurrentIndex(index >= images.length ? 0 : index);
                setPause(true);
                break;
            default:
                setCurrentIndex(direction);
                setPause(true);
                break;
        };

        setSlideInfo({
            slideIndex: currentIndex,
            slideShow: images[currentIndex]
        })

    };


    return (
        <div className="login_slideshow">
            <SlideItem
                content={slideShow}
            />
            <Indicators
                changeSlide={goTo}
                currentSlide={slideIndex}
            />
        </div>

    )

}

export default Slider;